import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../common/Icon';
import BottomSheet from '../common/BottomSheet';
import { ReactComponent as UserIcon } from '../../icons/user.svg';
import { ReactComponent as SettingIcon } from '../../icons/settings.svg';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as SongsIcon } from '../../icons/playlist.svg';
import { ReactComponent as LogOutIcon } from '../../icons/log-out.svg';
import { ReactComponent as StarIcon } from '../../icons/star-solid.svg';

import './NavBarMenu.scss';

// The phone's menu, opened from the avatar. The desktop keeps the bar's links and dropdown.
const NavBarMenu = ({ isOpen, onClose, user, showUpgrade }) => {
  const { t } = useTranslation();

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('nav.menu')} className="NavBarMenu">
      <NavLink className="identity" activeClassName="is-active" to="/myteam" onClick={onClose}>
        <span className="identity-avatar" aria-hidden="true">
          <Icon icon={<UserIcon />} />
        </span>
        <span className="identity-text">
          <span className="identity-name">{user.firstName}</span>
          <span className="identity-team">{user.teamName}</span>
        </span>
        <span className="identity-chevron" aria-hidden="true" />
      </NavLink>

      <nav className="rows" aria-label={t('nav.menu')}>
        <NavLink className="row" activeClassName="is-active" to="/songs" onClick={onClose}>
          <Icon icon={<SongsIcon />} />
          <span>{t('nav.songs')}</span>
        </NavLink>
        <NavLink className="row" activeClassName="is-active" to="/searchsongs" onClick={onClose}>
          <Icon icon={<SearchIcon />} />
          <span>{t('nav.publicSongs')}</span>
        </NavLink>

        <div className="divider" />

        {showUpgrade && (
          <NavLink className="row row--upgrade" activeClassName="is-active" to="/subscribe" onClick={onClose}>
            <Icon icon={<StarIcon />} className="solid" />
            <span>{t('nav.goUnlimited')}</span>
          </NavLink>
        )}
        <NavLink className="row" activeClassName="is-active" to="/settings" onClick={onClose}>
          <Icon icon={<SettingIcon />} />
          <span>{t('nav.settings')}</span>
        </NavLink>
        <Link className="row" to="/signout" onClick={onClose}>
          <Icon icon={<LogOutIcon />} />
          <span>{t('nav.signOut')}</span>
        </Link>
      </nav>
    </BottomSheet>
  );
};

export default NavBarMenu;
